import { makeStyles } from 'tss-react/mui';

import {typeTheme, typographyTheme} from "web-library/theme/helper/tssHelper"
// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  // main CSS for each element
  formElementContainer: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
    width: '100%',
  },
  halfWidthLeftItem: {
    width: '50% !important',
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingRight: 0,
    },
  },
  halfWidthRightItem: {
    width: '50% !important',
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingLeft: 0,
    },
  },
  groupFormElementContainer: {
    marginBottom: theme.spacing(1),
    width: '100%',
  },
  groupHalfWidthLeftItem: {
    width: '50%',
    paddingRight: 4,
  },
  groupHalfWidthRightItem: {
    width: '50%',
    paddingLeft: 4,
  },

  // other CSS
  mainContainer: {
    width: '100%',
    maxWidth: 960,
  },
  responsiveFlexContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  editLink: {
     ...typeTheme(theme, 'buttonSmall'),
  },
  form: {
    width: '90%',
  },
  formHeader: {
    width: '100%',
  },
  groupMultirowContainer: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  groupSingleRowContainer: {
    display: 'flex',
    displayDirection: 'row',
    width: '100%',
  },
  submitButton: {
    width: '100%',
  },
   label: {...typographyTheme(theme, 'subtitle2')},
  groupOfInputsLabel: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  preferredLabel: {
    marginLeft: theme.spacing(2),
    display: 'inline',
  },
  extraInfoText: {
    color: theme.color.text.textSecondary,
    marginBottom: theme.spacing(2),
  },
  submitButtonContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  formControl: {
    width: '100%',
  },
  divider: {
    height: 0,
    width: '100%',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(6),
    borderWidth: 0,
    borderTopWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.color.border.borderAlt,
  },
  backButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
  requiredLabel: {
    color: theme.color.state.stateImportant,
    marginLeft: theme.spacing(0.5),
    display: 'inline',
  },
  disabled: {
    color: theme.color.text.textDisabled,
  },
  disabledLabel: {
    color: theme.color.text.textDisabled,
    marginLeft: theme.spacing(0.5),
    display: 'inline',
  },
  dividerContainer: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));
